module.exports = __webpack_public_path__ + "static/media/gallerium.e51af724.jpg";